(() => {
  'use strict';
  const root = document.querySelector('[data-ngp]');
  if (!root) return;
  const mainLink = root.querySelector('[data-main-image]');
  const mainImage = mainLink?.querySelector('img');
  const thumbs = [...root.querySelectorAll('[data-gallery-item]')];
  const counter = root.querySelector('[data-image-count]');
  const caption = root.querySelector('[data-image-caption]');
  const dialog = root.querySelector('[data-image-dialog]');
  const titles = ['セット全体', 'ランダムで届くマウスパッド', 'SlickPen', 'Aqua 6.7mm', 'セット価格', 'セット内容・購入条件'];
  let selected = 0;
  function selectImage(index, moveFocus = false) {
    const link = thumbs[index];
    if (!link || !mainImage) return;
    selected = index;
    mainImage.src = link.href;
    mainImage.srcset = link.dataset.srcset || '';
    mainImage.alt = link.dataset.alt || link.querySelector('img').alt;
    mainLink.href = link.href;
    mainLink.setAttribute('aria-label', `${titles[index] || '商品画像'}を拡大する`);
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
    if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;
    if (caption) caption.textContent = titles[index] || '商品画像';
    if (moveFocus) link.focus();
  }
  thumbs.forEach((link, index) => {
    link.addEventListener('click', event => { event.preventDefault(); selectImage(index); });
    link.addEventListener('keydown', event => {
      let next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + thumbs.length) % thumbs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = thumbs.length - 1;
      else return;
      event.preventDefault(); selectImage(next, true);
    });
  });
  if (mainLink && dialog && typeof dialog.showModal === 'function') {
    mainLink.addEventListener('click', event => {
      event.preventDefault();
      const zoom = dialog.querySelector('img');
      zoom.src = mainLink.href; zoom.alt = mainImage.alt;
      dialog.showModal();
    });
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
  }
  const form = root.querySelector('[data-purchase-form]');
  const submit = form?.querySelector('[type=submit]');
  const status = root.querySelector('[data-sale-status]');
  const label = root.querySelector('[data-submit-label]');
  const quantity = form?.querySelector('[name=quantity]');
  // The app places its warning beside quantity inputs by default. Keep it
  // outside this compact label so the message uses the full purchase width.
  function positionPurchaseLimitNotice() {
    const banner = form?.querySelector('#soply-purchase-limits-message-root-product');
    if (banner && banner.parentElement !== form) form.insertBefore(banner, status);
  }
  positionPurchaseLimitNotice();
  if (form) {
    const noticeObserver = new MutationObserver(positionPurchaseLimitNotice);
    noticeObserver.observe(form, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => noticeObserver.disconnect());
  }

  let checkingCart = false;
  let cartCheckApproved = false;
  if (quantity) { quantity.max = '1'; quantity.readOnly = true; quantity.value = '1'; }
  const starts = Date.parse('2026-10-13T00:00:00+09:00');
  const ends = Date.parse('2026-10-20T00:00:00+09:00');
  const suppliedNow = Number(root.dataset.serverNow) * 1000;
  const baseNow = suppliedNow || Date.now();
  const clockStart = performance.now();
  const now = () => baseNow + performance.now() - clockStart;
  const available = root.dataset.available === 'true';
  const local = root.dataset.local === 'true';
  function saleState() {
    if (now() < starts) return ['before', '10/13 0:00 販売開始', '販売開始までお待ちください。限定20セット、なくなり次第終了です。'];
    if (now() >= ends) return ['after', '販売期間が終了しました', '感謝祭の販売期間は終了しました。'];
    if (!available) return ['soldout', '完売しました', '予定数量に達したため、販売を終了しました。'];
    return ['open', 'カートに追加する', '数量に達し次第終了します。送料はチェックアウトで確認できます。'];
  }
  function updateSale() {
    const [state, text, note] = saleState();
    if (submit) submit.disabled = state !== 'open' || local || checkingCart;
    if (quantity) quantity.disabled = state !== 'open' || local;
    if (label) label.textContent = text;
    if (status) status.textContent = note;
    root.dataset.saleState = state;
  }
  updateSale();
  let timer = setInterval(updateSale, 15000);
  window.addEventListener('pagehide', () => clearInterval(timer));
  window.addEventListener('pageshow', () => {
    updateSale(); clearInterval(timer); timer = setInterval(updateSale, 15000);
  });
  form?.addEventListener('submit', async event => {
    updateSale();
    if (saleState()[0] !== 'open' || local) { event.preventDefault(); return; }
    if (quantity) quantity.value = '1';
    if (cartCheckApproved) { cartCheckApproved = false; return; }
    event.preventDefault();
    if (checkingCart) return;
    checkingCart = true;
    updateSale();
    if (status) status.textContent = 'カートの数量を確認しています。';
    try {
      const shopRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${shopRoot}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const variantId = form.querySelector('[name=id]').value;
      if (cart.items.some(item => String(item.variant_id) === variantId && item.quantity > 0)) {
        if (status) status.textContent = '1注文につき1セットまでです。すでにカートに入っています。';
        window.location.assign(`${shopRoot}cart`);
        return;
      }
      checkingCart = false;
      updateSale();
      if (saleState()[0] !== 'open') return;
      cartCheckApproved = true;
      form.requestSubmit(submit);
    } catch (_) {
      checkingCart = false;
      updateSale();
      if (status) status.textContent = 'カートを確認できませんでした。もう一度お試しください。';
    }
  });
  const bar = root.querySelector('[data-mobile-bar]');
  const purchase = root.querySelector('#purchase');
  if (bar && purchase && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    });
    observer.observe(purchase);
  }
})();
